import React, {useState, useEffect} from 'react';
import {Button} from 'react-bootstrap';
import ReactLoading from 'react-loading';
import {getBoolUserInTourney, joinTournament, leaveTournament} from '../utils/firebase-config';

function TourneyRegisterButton(props) {
    const name = props.username;
    const tournament_name = props.tournamentname;
    const [InTourney, setInTounrey] = useState(false);
    const [Loading, setLoading] = useState(true) 

    const checkintourney = async() => {
        setLoading(true);
        console.log(name, tournament_name);
        var isopen = await getBoolUserInTourney(name,tournament_name)
        setInTounrey(isopen)
        setLoading(false);
      }

    const joint = async(name,tournament_name) => {
        await joinTournament(name,tournament_name);
        checkintourney();
    }

    const leavet = async(name,tournament_name) => {
        console.log(name, tournament_name)
        await leaveTournament(name,tournament_name);
        checkintourney();
    }

    useEffect(() => {
        checkintourney();
    }, [])

    if(Loading){
    return(
    <div className="busy">
        <ReactLoading type='bars' color='grey' height={'2vw'} width={'2vw'} />
    </div>
    )
    }
    else{
        if(InTourney == false){
            return (
                <><Button variant="success" onClick={() => joint(name,tournament_name)}>join</Button></>
            )
        }if(InTourney == true){
            return (
                <><Button variant="danger" onClick={() => leavet(name,tournament_name)}>leave</Button></>
            )
        }else{
            return(<></>)
        }
    }


    
}

export default TourneyRegisterButton